module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-415.1596792.woff2";